import { useCallback, useEffect, useRef } from "react";

import { throttle } from "lodash-es";

const useThrottle = <T extends (...args: any[]) => any>(
  cb: T,
  delay: number,
) => {
  const options = { leading: true, trailing: true };
  const cbRef = useRef<T>(cb);

  useEffect(() => {
    cbRef.current = cb;
  });

  return useCallback(
    throttle((...args) => cbRef.current(...args), delay, options),
    [delay],
  );
};

export default useThrottle;
